export const sectionTemplates = [
  {
    type: 'hero',
    label: 'Hero Banner',
    description: 'Large hero with title, subtitle, media and CTA',
    defaults: {
      title: 'Welcome to Ortus FMCG',
      subtitle: 'Digital-first, consumer obsessed',
      content: '<p>Build your hero section with media, overlay text and call-to-actions.</p>',
      image: '',
      media_url: '',
      button_text: 'Learn More',
      button_link: '/about',
      bg_color: 'slate-900',
      text_color: 'light',
      meta: {
        align: 'center',
        overlay: true,
        badge: '',
      },
    },
  },
  {
    type: 'content',
    label: 'Content Block',
    description: 'Rich text content with optional image/video',
    defaults: {
      title: 'Our Mission',
      subtitle: '',
      content: '<p>Add your mission statement or key messaging here.</p>',
      image: '',
      media_url: '',
      button_text: '',
      button_link: '',
      bg_color: 'white',
      text_color: 'dark',
      meta: {
        contentAlign: 'left',
        contentWidth: 'medium',
        imagePosition: 'none',
        imageSize: 'large',
        imageRatio: 'auto',
        imageRadius: 'xl',
        padding: 'normal',
      },
    },
  },
  {
    type: 'image_text',
    label: 'Image + Text',
    description: 'Two-column layout for storytelling',
    defaults: {
      title: 'Innovation Meets Scale',
      subtitle: 'Modern FMCG Playbook',
      content: '<p>Explain your unique edge with visuals.</p>',
      image: '',
      media_url: '',
      button_text: 'Explore',
      button_link: '/investors',
      bg_color: 'white',
      text_color: 'dark',
      meta: {
        reverse: false,
        split: '50/50',
        contentAlign: 'left',
        imageSize: 'large',
        imageRatio: 'auto',
        imageRadius: '2xl',
        vAlign: 'center',
        imageShadow: 'lg',
      },
    },
  },
  {
    type: 'feature_grid',
    label: 'Feature Grid',
    description: 'Highlight 3-6 pillars or services',
    defaults: {
      title: 'Why Partner With Us',
      subtitle: '',
      content: '',
      bg_color: 'slate-50',
      text_color: 'dark',
      meta: {
        items: [
          { icon: '📦', title: 'Integrated Supply Chain', desc: 'End-to-end control from sourcing to shelf.' },
          { icon: '📊', title: 'Data-led Growth', desc: 'Predictive analytics driving repeat purchase.' },
          { icon: '🤝', title: 'Trusted Partnerships', desc: 'Working closely with distributors and investors.' },
        ],
      },
    },
  },
  {
    type: 'stats',
    label: 'Stats Grid',
    description: 'Display KPIs and impact numbers',
    defaults: {
      title: 'Scale And Impact',
      subtitle: '',
      content: '',
      bg_color: 'red-50',
      text_color: 'dark',
      meta: {
        stats: [
          { label: 'Products', value: '150+' },
          { label: 'Cities', value: '120+' },
          { label: 'Retail Partners', value: '30K+' },
          { label: 'Customer Rating', value: '4.9/5' },
        ],
      },
    },
  },
  {
    type: 'cta',
    label: 'Call To Action',
    description: 'Drive conversions with bold CTA',
    defaults: {
      title: 'Ready to collaborate?',
      subtitle: '',
      content: '<p>Join our journey to reimagine FMCG for Bharat.</p>',
      button_text: 'Connect With Us',
      button_link: '/contact',
      bg_color: 'slate-900',
      text_color: 'light',
      meta: {
        badge: 'Open Partnerships',
      },
    },
  },
  {
    type: 'timeline',
    label: 'Timeline / Milestones',
    description: 'Showcase company history or roadmap',
    defaults: {
      title: 'Our Journey',
      subtitle: 'Milestones',
      content: '',
      bg_color: 'white',
      text_color: 'dark',
      meta: {
        items: [
          { year: '2018', title: 'Founded', desc: 'Ortus FMCG begins with a vision to digitize FMCG.' },
          { year: '2020', title: '5000 Stores', desc: 'Achieved nationwide distribution footprint.' },
          { year: '2023', title: 'FMCG 2.0', desc: 'Launched omnichannel platform and D2C capabilities.' },
        ],
      },
    },
  },
  {
    type: 'team',
    label: 'Leadership Grid',
    description: 'Introduce leadership or advisory board',
    defaults: {
      title: 'Leadership Team',
      subtitle: 'Driving FMCG 2.0',
      content: '',
      bg_color: 'white',
      text_color: 'dark',
      meta: {
        people: [
          { name: 'CEO Name', title: 'Chief Executive Officer', photo: '', bio: 'Strategist with 20+ years in FMCG.' },
          { name: 'COO Name', title: 'Chief Operating Officer', photo: '', bio: 'Runs supply chain & operations.' },
          { name: 'CMO Name', title: 'Chief Marketing Officer', photo: '', bio: 'Leads brand & growth initiatives.' },
        ],
      },
    },
  },
  {
    type: 'faq',
    label: 'FAQ Accordion',
    description: 'Answer common questions',
    defaults: {
      title: 'Frequently Asked Questions',
      subtitle: '',
      content: '',
      bg_color: 'slate-50',
      text_color: 'dark',
      meta: {
        faqs: [
          { q: 'How do I partner with Ortus?', a: 'Use the contact form or distributor registration module.' },
          { q: 'Which categories do you operate in?', a: 'Food, home care, personal care, beauty, and new-age categories.' },
          { q: 'Do you support private labels?', a: 'Yes, through our enterprise solutions team.' },
        ],
      },
    },
  },
];

export const defaultSection = sectionTemplates[1];
